import axios from "axios";
import constants from "../constants";
const vuexLocal = window.localStorage.getItem("housesin");
const headers = {
  Authorization: ""
};
if (vuexLocal) {
  const data = JSON.parse(vuexLocal);
  if (data.token) {
    headers.Authorization = `Bearer ${data.token}`;
  }
}

let url = `${constants.API}api`;

const client = axios.create({
    baseURL: url,
    headers
  });

client.interceptors.response.use(response => {
  return response;
});

export default client;
